import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/InfoPanel.css';

InfoPanel.propTypes = {
    message: PropTypes.string.isRequired,
};

function InfoPanel(props) {
    const {
        message,
    } = props;
    return (
        <div className="info-panel">
            <FontAwesomeIcon icon="info-circle" className="info-panel--icon" />
            <span className="info-panel--message">
                {message}
            </span>
        </div>
    );
}

export default InfoPanel;
